import { BlockApiModel } from '../../../types/models/block.model';
import { SearchBlocksApiRequest } from '../../../types/requests/blocks/search-blocks.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { AddTemplateToBlockApiRequest } from '../../../types/requests/blocks/add-template-to-block.request';
import { RemoveTemplateFromBlockApiRequest } from '../../../types/requests/blocks/remove-template-from-block.request';
import { GetBlockApiRequest } from '../../../types/requests/blocks/get-block.request';
import { AddTemplatesToBlocksApiRequest } from '../../../types/requests/blocks/add-templates-to-blocks.request';
import { DeleteBlockApiRequest } from '../../../types/requests/blocks/delete-block.request';

export const createBlocks = (params: FormData) => client.post<BlockApiModel[]>('/blocks', params);

export const searchBlocks = <T extends BlockApiModel>(params: SearchBlocksApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/blocks`, { params });

export const addTemplateToBlock = ({ blockId, templateId }: AddTemplateToBlockApiRequest) =>
  client.post<void>(`/blocks/${blockId}/templates/${templateId}`);

export const addTemplatesToBlocks = (params: AddTemplatesToBlocksApiRequest) =>
  client.post<void>(`/blocks/templates`, params);

export const getBlock = <T extends BlockApiModel>({ blockId, ...params }: GetBlockApiRequest) =>
  client.get<T>(`/blocks/${blockId}`, { params });

export const removeTemplateFromBlock = ({ blockId, templateId }: RemoveTemplateFromBlockApiRequest) =>
  client.delete<void>(`/blocks/${blockId}/templates/${templateId}`);

export const deleteBlock = ({ blockId }: DeleteBlockApiRequest) => client.delete<void>(`/blocks/${blockId}`);
